import { env } from '../../../config/env';
import mockGamesData from '../api/mockMyGames.json';
import { Game } from '../types/gameTypes';

const knownGames = mockGamesData as Game[];

/**
 * Resolves an asset path, prepending the public URL prefix when applicable.
 */
export const getAssetUrl = (url?: string): string => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  const publicUrl = env().PUBLIC_URL;
  return url.startsWith('/') ? `${publicUrl}${url}` : `${publicUrl}/${url}`;
};

const LOWERCASE_WORDS = new Set([
  'a',
  'an',
  'and',
  'at',
  'by',
  'for',
  'in',
  'of',
  'on',
  'the',
  'to',
]);

const ACRONYMS = new Set(['VR', 'UEVR', 'PC', '6DOF', 'AI', 'P2P', 'HD']);

/**
 * Resolves a human-readable game title from a game identifier or slug.
 * Checks known mock games data first, and falls back to formatting the slug.
 */
export const resolveGameTitle = (id?: string): string => {
  if (!id) {
    return '';
  }

  const normalizedId = id.trim().toLowerCase();
  const matchedGame = knownGames.find(
    (g) => g.id.toLowerCase() === normalizedId || g.slug.toLowerCase() === normalizedId
  );

  if (matchedGame) {
    return matchedGame.title;
  }

  const words = normalizedId.split(/[-_]+/).filter(Boolean);
  if (words.length === 0) {
    return '';
  }

  return words
    .map((word, index) => {
      const upper = word.toUpperCase();
      if (ACRONYMS.has(upper)) {
        return upper;
      }
      if (index > 0 && LOWERCASE_WORDS.has(word)) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};
